import { getCurrentSelectedRatingInput } from './get-current-selected-rating-input';
import { getRatingHintByInput } from './get-rating-hint-by-input';

export type GetCurrentSelectedRatingHintParams = {
    rootElement: Pick<HTMLElement, 'querySelectorAll'>;
};
export const getCurrentSelectedRatingHint = ({ rootElement }: GetCurrentSelectedRatingHintParams) => {
    const selectedInput = getCurrentSelectedRatingInput({ rootElement });
    if (selectedInput === undefined) return 'Bitte wählen';

    return getRatingHintByInput({ input: selectedInput });
};
